export const LoanConditionTasksTableColumnId = {
  NAME: 'name',
  LAST_MODIFIED: 'lastModified',
  STATUS: 'status',
  SLA_LEVEL_DETAILS: 'slaLevelDetails',
};

export const LOAN_CONDITION_TASKS_COLUMN_COUNT = Object.keys(
  LoanConditionTasksTableColumnId,
).length;

export const COLUMN_WIDTH = {
  NAME: '50%',
  LAST_MODIFIED: '25%',
  STATUS: '25%',
};
